/* CloudTopper nav: desktop dropdowns (hover, click, keyboard) and the drawer overlay tint.
   Drawer open/close itself is handled by theme.Drawers in freedom.js. */
(function () {
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initDropdowns(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ct-drop]'));
    if (!items.length) return;

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var trigger = item.querySelector('.ct-nav__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) setOpen(item, false);
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.ct-nav__trigger');
      var timer;

      trigger.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        closeAll(item);
        setOpen(item, open);
      });

      item.addEventListener('mouseenter', function () {
        if (!hoverable.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { closeAll(item); setOpen(item, true); }, 80);
      });

      item.addEventListener('mouseleave', function () {
        if (!hoverable.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { setOpen(item, false); }, 160);
      });

      item.addEventListener('focusout', function (evt) {
        if (!item.contains(evt.relatedTarget)) setOpen(item, false);
      });

      item.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape' && item.classList.contains('is-open')) {
          setOpen(item, false);
          trigger.focus();
        }
      });
    });

    document.addEventListener('click', function (evt) {
      if (!evt.target.closest('[data-ct-drop]')) closeAll();
    });

    // Esc also closes a panel opened by hover, when focus is outside the nav
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') closeAll();
    });
  }

  function initOverlayTint() {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer || !drawer.classList.contains('ct-drawer')) return;
    var html = document.documentElement;
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      if (drawer.classList.contains('drawer--is-open')) {
        html.classList.add('ct-nav-open');
      } else {
        // keep the navy tint until the theme's overlay fade-out finishes
        timer = setTimeout(function () { html.classList.remove('ct-nav-open'); }, 300);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    var header = document.getElementById('SiteHeader');
    if (header) initDropdowns(header);
    initOverlayTint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector('#SiteHeader')) init();
  });
})();
